import { applicationCreateRoute } from "modules/applications";
import { userManagementRoutes } from "modules/user-management";

export const NON_ENV_BASED_ROUTES = [
  userManagementRoutes.path,
  applicationCreateRoute.path,
] as const;
